import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { loginRequest } from './auth-config';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
})
export class AppComponent
{
    constructor(private authService: MsalService)
    {
    }

    ngOnInit() {
        console.log('MSAL Service:', this.authService);
        console.log('All Accounts:', this.authService.instance.getAllAccounts());
        console.log('Active Account:', this.authService.instance.getActiveAccount());
        
        // this.authService.instance
        //     .acquireTokenSilent(loginRequest)
        //     .then(res => {
        //         console.log('MSAL Token', res.accessToken);
        //     });
    }
}

export function sortOnProperty<T> (items: T[], property: string, isAsc: boolean = true): T[] {
    if (isAsc) {
        return items.sort((a, b) => (a[property] > b[property]) ? 1 : ((b[property] > a[property]) ? -1 : 0))
    } else {
        return items.sort((a, b) => (a[property] > b[property]) ? -1 : ((b[property] > a[property]) ? 1 : 0))
    }
}

export function sortOnSelf<T> (items: T[], isAsc: boolean = true): T[] {
    if (isAsc) {
        return items.sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0))
    } else {
        return items.sort((a, b) => (a > b) ? -1 : ((b > a) ? 1 : 0))
    }
}

export function sumList (arr: number[]) {
    return arr.reduce((prev, cur) => +prev + +cur, 0); //+x is a unary function to parse number, this isn't a typo
}

export function getParentUrl(_router: Router) {
    return _router.url.split('/').slice(0, -1).join('/');
}

export function capitaliseFirstLetter(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
}

export function joinNiceList(words: string[]) {
    if(words.length < 2)
        return words.join();

    var lastWord = words.pop();
    return words.join(', ') + " and " + lastWord;
}

export function getUniqueOnSelf(array: any[]) {
    if(!array || !array.length) return [];
    return array.filter((val, i, arr) => arr.indexOf(val) === i)
}

export function getUniqueOnProp(array: any[], property: string) {
    if(!array || !array.length) return [];
    return array.filter((val, i, arr) => arr.map(x => x[property]).indexOf(val[property]) === i)
}
